import { Component, Inject, ViewEncapsulation } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog } from '@angular/material';
import { FormAnswers, QuestionAnswer } from '@core/interfaces';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import { isString } from 'lodash';
import english from '../../../../i18n/en.json';
import spanish from '../../../../i18n/es.json';
import portuguese from '../../../../i18n/pt.json';
import { MaintenanceDialogData } from '../../dialog-maintenances.component';
import { FormDetailsComponent } from './form-details/form-details.component';

@Component({
  selector: 'tab-forms',
  templateUrl: './tab-forms.component.html',
  styleUrls: ['./tab-forms.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class TabFormsComponent {
  public forms: FormAnswers[];
  public allForms: FormAnswers[];

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: MaintenanceDialogData,
    private fuseTranslationLoaderService: FuseTranslationLoaderService,
    private matDialog: MatDialog
  ) {
    this.fuseTranslationLoaderService.loadJsonTranslations({ english, portuguese, spanish });
    this.allForms = data.maintenance.formAnswers;
    this.forms = this.allForms;
  }

  public openForm(questionAnswers: QuestionAnswer[], formTitle: string): void {
    this.matDialog.open(FormDetailsComponent, {
      panelClass: 'dialog-edit-maintenance',
      data: {
        questionAnswers,
        formTitle
      }
    });
  }

  public filterForms(value: string): void {
    if (!value) {
      this.forms = this.allForms;
      return;
    }

    const filterValue = value.toUpperCase();

    this.forms = this.allForms.filter(({ name, questionAnswers }) => {
      const matchName = isString(name) && name.toUpperCase().includes(filterValue);
      const matchAnswers = questionAnswers.some((qa) => isString(qa.answer) && qa.answer.toUpperCase().includes(filterValue));

      return matchName || matchAnswers;
    });
  }
}
